// extracted by mini-css-extract-plugin
module.exports = {"prompt":"QuestionCard_prompt__8cden","buttons":"QuestionCard_buttons__CxNqC"};